module.exports = __webpack_public_path__ + "img/logo-blue.88ab8d2a.png";